/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuthProtocolFindPasswordCheckRequest,
  AuthProtocolFindPasswordCheckResponse,
  AuthProtocolFindPasswordResetRequest,
  AuthProtocolFindPasswordResetResponse,
  AuthProtocolFindPasswordSendRequest,
  AuthProtocolFindPasswordSendResponse,
  AuthProtocolFindPasswordVerifyRequest,
  AuthProtocolLoginRequest,
  AuthProtocolLoginResponse,
  AuthProtocolRefreshTokenRequest,
  AuthProtocolRefreshTokenResponse,
  AuthProtocolRegisterNewClientRequest,
  AuthProtocolSignupRequest,
  AuthProtocolSignupResponse,
  AuthProtocolSignupVerifyCheckRequest,
  AuthProtocolSignupVerifyCheckResponse,
  AuthProtocolSignupVerifyRequest,
  AuthProtocolSignupVerifySendRequest,
  AuthProtocolSignupVerifySendResponse,
  AuthProtocolVerifyEmailRequest,
  AuthProtocolVerifyEmailResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Auth<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Auth
   * @name SignupVerifySendCreate
   * @request POST:/auth/signup/verify/send
   */
  signupVerifySendCreate = (data: AuthProtocolSignupVerifySendRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolSignupVerifySendResponse, any>({
      path: `/auth/signup/verify/send`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name SignupVerifyCheckCreate
   * @request POST:/auth/signup/verify/check
   */
  signupVerifyCheckCreate = (data: AuthProtocolSignupVerifyCheckRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolSignupVerifyCheckResponse, any>({
      path: `/auth/signup/verify/check`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name SignupVerifyCreate
   * @request POST:/auth/signup/verify
   */
  signupVerifyCreate = (data: AuthProtocolSignupVerifyRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/auth/signup/verify`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name SignupCreate
   * @request POST:/auth/signup
   */
  signupCreate = (data: AuthProtocolSignupRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolSignupResponse, any>({
      path: `/auth/signup`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name LoginCreate
   * @request POST:/auth/login
   */
  loginCreate = (data: AuthProtocolLoginRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolLoginResponse, any>({
      path: `/auth/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name RefreshCreate
   * @request POST:/auth/refresh
   */
  refreshCreate = (data: AuthProtocolRefreshTokenRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolRefreshTokenResponse, any>({
      path: `/auth/refresh`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name FindVerifySendCreate
   * @request POST:/auth/find/verify/send
   */
  findVerifySendCreate = (data: AuthProtocolFindPasswordSendRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolFindPasswordSendResponse, any>({
      path: `/auth/find/verify/send`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name FindVerifyCheckCreate
   * @request POST:/auth/find/verify/check
   */
  findVerifyCheckCreate = (data: AuthProtocolFindPasswordCheckRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolFindPasswordCheckResponse, any>({
      path: `/auth/find/verify/check`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name FindVerifyCreate
   * @request POST:/auth/find/verify
   */
  findVerifyCreate = (data: AuthProtocolFindPasswordVerifyRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/auth/find/verify`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name FindResetCreate
   * @request POST:/auth/find/reset
   */
  findResetCreate = (data: AuthProtocolFindPasswordResetRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolFindPasswordResetResponse, any>({
      path: `/auth/find/reset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name RegisterCreate
   * @request POST:/auth/register
   */
  registerCreate = (data: AuthProtocolRegisterNewClientRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/auth/register`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name EmailVerifyCreate
   * @request POST:/auth/email/verify
   */
  emailVerifyCreate = (data: AuthProtocolVerifyEmailRequest, params: RequestParams = {}) =>
    this.http.request<AuthProtocolVerifyEmailResponse, any>({
      path: `/auth/email/verify`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
